import { Button } from "@mantine/core";
import type { IDrofusInterfaceChangeType } from "@multiconsult-group/multiplacer-core";

export const DROFUS_CHANGE_TYPE_OPTIONS: Array<{
  value: IDrofusInterfaceChangeType;
  label: string;
  color: string;
  activeBackground: string;
  activeColor: string;
  inactiveBackground: string;
  inactiveColor: string;
  borderColor: string;
}> = [
  {
    value: "updated",
    label: "Endret",
    color: "yellow",
    activeBackground: "#f59f00",
    activeColor: "#1f2937",
    inactiveBackground: "#fff7db",
    inactiveColor: "#8a5a00",
    borderColor: "#f59f00",
  },
  {
    value: "added",
    label: "Ny",
    color: "green",
    activeBackground: "#2f9e44",
    activeColor: "#ffffff",
    inactiveBackground: "#eaf8ef",
    inactiveColor: "#23793a",
    borderColor: "#2f9e44",
  },
  {
    value: "removed",
    label: "Fjernet",
    color: "red",
    activeBackground: "#e03131",
    activeColor: "#ffffff",
    inactiveBackground: "#fff0f0",
    inactiveColor: "#c92a2a",
    borderColor: "#e03131",
  },
];

type DrofusChangeTypeFilterProps = {
  selectedChangeTypes: IDrofusInterfaceChangeType[];
  onToggleChangeType: (changeType: IDrofusInterfaceChangeType) => void;
  size?: "xs" | "sm";
  fullWidth?: boolean;
};

export const DrofusChangeTypeFilter: React.FC<DrofusChangeTypeFilterProps> = ({
  selectedChangeTypes,
  onToggleChangeType,
  size = "xs",
  fullWidth = false,
}) => (
  <Button.Group w={fullWidth ? "100%" : undefined}>
    {DROFUS_CHANGE_TYPE_OPTIONS.map((option) => {
      const isSelected = selectedChangeTypes.includes(option.value);

      return (
        <Button
          key={option.value}
          size={size}
          color={option.color}
          variant="filled"
          onClick={() => onToggleChangeType(option.value)}
          style={{
            flex: fullWidth ? 1 : undefined,
            height: size === "sm" ? 46 : undefined,
            fontSize: size === "sm" ? 16 : undefined,
            fontWeight: 700,
            borderColor: option.borderColor,
            color: isSelected ? option.activeColor : option.inactiveColor,
            backgroundColor: isSelected ? option.activeBackground : option.inactiveBackground,
          }}
        >
          {option.label}
        </Button>
      );
    })}
  </Button.Group>
);
